import { GearboxFooter, Layout } from "@gearbox-protocol/ui-kit";
import { Toaster } from "sonner";
import { HeaderLayout } from "./header";

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <Layout
      header={<HeaderLayout />}
      footer={
        <GearboxFooter
          appName="Governance"
          showLegalLinks
          showDeveloperLinks
          legalReferences={{
            termsOfService: "/legal/terms-of-service",
            privacyNotice: "/legal/privacy-notice",
            riskDisclosure: "/legal/risk-disclosure",
          }}
        />
      }
    >
      <Toaster position="top-right" richColors theme="dark" closeButton />
      {children}
    </Layout>
  );
}
